
import { Reminder } from './types';

// Empty array for new users to start with a clean slate
export const mockReminders: Reminder[] = [];
